<template>
  <div class="course-edit">
    <div class="div_steps_contrain">
      <el-steps :active="active" finish-status="success" align-center>
        <el-step title="基本信息"></el-step>
        <el-step title="课程上传"></el-step>
        <el-step title="课件上传"></el-step>
      </el-steps>
    </div>
    <div class="course-edit-content">
      <CourseInfo
        :courseCode="courseCode"
        @success="saveCourseCode"
        v-if="active === 0"
      />
      <CourseList
        :courseCode="courseCode"
        @next="nextStep"
        @previous="previousStep"
        v-if="active === 1"
      />
      <CourseWare
        :courseCode="courseCode"
        @previous="previousStep"
        v-if="active === 2"
      />
    </div>
  </div>
</template>
<script>
import CourseInfo from "./CourseInfo.vue";
import CourseList from "./CourseList.vue";
import CourseWare from "./CourseWare.vue";
export default {
  components: {
    CourseInfo,
    CourseList,
    CourseWare
  },
  data() {
    return {
      courseCode: this.$route.query.courseCode,
      active: 0
    };
  },
  watch: {
    "$route.query.courseCode"(val) {
      this.courseCode = val;
      this.active = 0;
    }
  },
  methods: {
    saveCourseCode(courseCode) {
      this.courseCode = courseCode;
      this.active++;
    },
    nextStep() {
      this.active++;
    },
    previousStep() {
      this.active--;
    }
  },
  created() {
    this.courseCode = this.$route.query.courseCode;
  }
};
</script>
<style scoped lang="less">
.course-edit {
  .div_steps_contrain {
    background: #ffffff;
    border-radius: 8px;
    padding: 12px 10%;

    /deep/.el-step__head.is-success {
      color: #1890ff;
      border-color: #1890ff;
    }

    /deep/.el-step__title.is-success {
      color: #1890ff;
    }
  }
  .course-edit-content {
    padding: 24px 10%;
    margin: 15px 0;
    background: #ffffff;
    border-radius: 8px;
  }
}
/deep/ .el-step.is-center .el-step__line {
  bottom: 18px;
  top: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/CourseEdit/index.vue